import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';
import { Heading } from '../../../components';
import S3ImageDisplay from '../../../components/S3ImageDisplay/S3ImageDisplay';
import { languagesHelper as language } from '../../../helpers/languages';

import css from './StoreDetailsSectionListingPage.module.css';

const StoreDetailsSectionListingPage = props => {
  const { currentListing, rootClassName, listingPage, listingFieldsConfig, intl } = props;

  // Ensure currentListing is defined
  const attributes = currentListing?.attributes || {};
  const publicData = attributes.publicData || {};
  const title = attributes.title || '';
  const description = attributes.description || '';

  const {
    openingHours,
    storeSize,
    measureUnit,
    teamMembers,
    productGroup,
    productPositioning,
    productType,
    storeLabels,
    closedOnHolidays,
  } = publicData;

  // Ensure openingHours is defined and is an object
  const validOpeningHours = openingHours && typeof openingHours === 'object';
  // Define the order of the days
  const dayOrder = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

  // Define display labels for days
  const dayLabels = {
    monday: intl.formatMessage({ id: 'StoreDetailsSection.monday' }),
    tuesday: intl.formatMessage({ id: 'StoreDetailsSection.tuesday' }),
    wednesday: intl.formatMessage({ id: 'StoreDetailsSection.wednesday' }),
    thursday: intl.formatMessage({ id: 'StoreDetailsSection.thursday' }),
    friday: intl.formatMessage({ id: 'StoreDetailsSection.friday' }),
    saturday: intl.formatMessage({ id: 'StoreDetailsSection.saturday' }),
    sunday: intl.formatMessage({ id: 'StoreDetailsSection.sunday' }),
  };

  // Convert the object to an array of entries and sort by defined order
  const sortedDays = validOpeningHours
    ? Object.entries(openingHours).sort(
      ([dayA], [dayB]) => {
        const indexA = dayOrder.indexOf(dayA);
        const indexB = dayOrder.indexOf(dayB);
        // Если день не найден в dayOrder, он уходит в конец списка
        return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
      }
    )
    : [];

  const mappedHours = sortedDays.map(([day, times], index) => {
    const openTime =
      times.open === 'Closed'
        ? intl.formatMessage({ id: 'StoreDetailsSection.closed' })
        : `${times.open} - ${times.close}`;

    return (
      <div className={css.schedule} key={index}>
        <label>{dayLabels[day] || day}</label>
        <span className={css.time}>{openTime}</span>
      </div>
    );
  });

  let currentLocale = language.get();
  const isDe = currentLocale === "de";

  const formattedMeasureUnite = measureUnit === 'm2' ? 'm²' : 'ft²';

  const productPositioningOptions =
    listingFieldsConfig?.find(c => c.key === 'productPositioning').associations || {};
  const formattedProductPositioningArray = productPositioning?.map(
    item => productPositioningOptions?.[item]
  );

  const getLabelsByOptions = (optionValues, listingKey, splitDot = false) => {

    const options = listingFieldsConfig.find(c => c.key === listingKey).enumOptions;
    const labels = optionValues.map(optionValue => {
      const matchingOption = options.find(option => option.option === optionValue);
      const label = isDe && matchingOption?.labelDe ? matchingOption?.labelDe : matchingOption?.label
      return matchingOption ? label : intl.formatMessage({ id: 'EditListingForm.optionNotFound' });
    });

    return splitDot ? labels?.join(' • ') : labels?.join(', ');
  };

  return (
    <div className={rootClassName || css.root}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="StoreDetailsSection.productTitle" />
      </Heading>
      <p className={css.content}>
        <FormattedMessage id="StoreDetailsSection.productDescription" />
      </p>

      <section>
        {productGroup && (
          <div className={classNames(css.groups, css.denseGrouping)}>
            <label className={css.mainLabel}>
              <FormattedMessage id="StoreDetailsSection.productGroupLabel" />
            </label>
            {/* {productGroup.map(item => item.charAt(0).toUpperCase() + item.slice(1)).join(', ')} */}
            {getLabelsByOptions(productGroup, 'productGroup')}
          </div>
        )}

        {productType && (
          <div className={classNames(css.groups, css.denseGrouping)}>
            <label className={css.mainLabel}>
              <FormattedMessage id="StoreDetailsSection.productCategoryLabel" />
            </label>
            {/* {productType.map(item => item.charAt(0).toUpperCase() + item.slice(1)).join(', ')} */}
            {getLabelsByOptions(productType, 'productType')}
          </div>
        )}

        {productPositioning && (
          <div className={classNames(css.groups, css.denseGrouping)}>
            <label className={css.mainLabel}>
              <FormattedMessage id="StoreDetailsSection.productPositioningLabel" />
            </label>
            {formattedProductPositioningArray
              .map(item => (isDe ? item?.labelDe : item?.label))
              .join(', ')}
          </div>
        )}

        {storeLabels && (
          <div className={classNames(css.groups, css.denseGrouping)}>
            <label className={css.mainLabel}>
              <FormattedMessage id="StoreDetailsSection.styleFunctionLabel" />
            </label>
            {/* {storeLabels.map(item => item.charAt(0).toUpperCase() + item.slice(1)).join(', ')} */}
            {getLabelsByOptions(storeLabels, 'storeLabels')}
          </div>
        )}
      </section>

      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="StoreDetailsSection.aboutTitle" values={{ title }} />
      </Heading>

      <section>
        <div className={css.size}>
          <label className={css.mainLabel}>
            <FormattedMessage id="StoreDetailsSection.storeSizeLabel" />
          </label>
          {storeSize + ' ' + formattedMeasureUnite}
        </div>

        {/*<div className={css.address}>*/}
        {/*  <label className={css.mainLabel}>*/}
        {/*    <FormattedMessage id="StoreDetailsSection.addressLabel" />*/}
        {/*  </label>*/}
        {/*  {location?.address}*/}
        {/*</div>*/}

        {openingHours && (
          <div>
            <label className={css.mainLabel}>
              <FormattedMessage id="StoreDetailsSection.scheduleLabel" />
            </label>
            {mappedHours}
          </div>
        )}

        {closedOnHolidays && (
          <div className={css.closedOnHolidaysText}>
            <FormattedMessage id="StoreDetailsSection.closedOnHolidays" />
          </div>
        )}

        <div className={listingPage ? css.description : css.descriptionEditListing}>
          {!listingPage && <strong>
            <FormattedMessage id="StoreDetailsSection.desccription" />
          </strong>}
          {description}
        </div>

        {/*{locationType && (*/}
        {/*  <div className={css.groups}>*/}
        {/*    <label className={css.mainLabel}>*/}
        {/*      <FormattedMessage id="StoreDetailsSection.shopSettingLabel" />*/}
        {/*    </label>*/}
        {/*    {locationType.map(item => item.charAt(0).toUpperCase() + item.slice(1)).join(', ')}*/}
        {/*  </div>*/}
        {/*)}*/}

        {/*<div className={classNames(css.groups, css.denseGrouping)}>*/}
        {/*  <label className={classNames(css.mainLabel, css.fitLabel)}>*/}
        {/*    <FormattedMessage*/}
        {/*      id="StoreDetailsSection.productFitLabel"*/}
        {/*      values={{*/}
        {/*        explanation: (*/}
        {/*          <span className={css.fitLabelExpl}>*/}
        {/*            {intl.formatMessage({ id: 'StoreDetailsSection.productFitExplain' })}*/}
        {/*          </span>*/}
        {/*        ),*/}
        {/*      }}*/}
        {/*    />*/}
        {/*  </label>*/}
        {/*</div>*/}

        {/*{storeLabels && (*/}
        {/*  <div className={css.groups}>*/}
        {/*    <label className={css.mainLabel}>*/}
        {/*      <FormattedMessage id="StoreDetailsSection.brandPreferencesLabel" />*/}
        {/*    </label>*/}
        {/*    {storeLabels.map(item => item.charAt(0).toUpperCase() + item.slice(1)).join(', ')}*/}
        {/*  </div>*/}
        {/*)}*/}
        {teamMembers && (
          <div
            className={classNames(css.groups, css.groupsMobile)}
          // style={{ marginTop: 16, alignItems: 'flex-start' }}
          >
            <label className={css.mainLabel}>
              <FormattedMessage id="StoreDetailsSection.teamMembersLabel" />
            </label>
            <div className={css.membersContainer}>
              {teamMembers.map((member, index) => {
                return (
                  <div className={css.member}>
                    <S3ImageDisplay value={member.image} isRounded />
                    <span style={{ marginTop: 16 }}>{member.teamMemberRole}</span>
                    <span>{member.teamMemberName}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </section>
    </div>
  );
};

export default StoreDetailsSectionListingPage;
